import { API_ROUTE_ADMIN_FEATURE_DETAILS_BY_CODE } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

type FeatureDetailsByCodeOriginal = {
  id: number
  name: string
  description: string
}

export const getFeatureDetailsByCode = (code: string) =>
  get<FeatureDetailsByCodeOriginal>(
    API_ROUTE_ADMIN_FEATURE_DETAILS_BY_CODE.replace(':featureCode', code),
    IS_NEW_BACKEND_API
  )
